import { render, staticRenderFns } from "./modalIngresarDinero.vue?vue&type=template&id=47dadc55"
import script from "./modalIngresarDinero.vue?vue&type=script&lang=js"
export * from "./modalIngresarDinero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports